module.exports = __webpack_public_path__ + "static/img/101_TO8_1782_og.63ae259.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/101_TO8_1782_og.jpg
// module id = 73oU
// module chunks = 0